<template>
  <svg v-if="oldSelectedOption.length > 0" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20" class="arrow-back" @click="$emit('update-old-selected-option');">
    <path
      stroke="#333"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="0.5"
      d="M6 8l4 4 4-4"
      transform="rotate(90, 10, 10)"
    />
  </svg>
</template>

<script>
export default {
  name: "ArrowBack",
  props: {
    oldSelectedOption: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style scoped>
.arrow-back {
  position: absolute !important;
  top: 20px !important;
  left: 20px !important;
  width: 20px !important;
  height: 20px !important;
  cursor: pointer !important;
  stroke: #333 !important;
  transform: scale(1.5) !important;
}
</style>
